import { render, staticRenderFns } from "./vip-list.vue?vue&type=template&id=e2603c90&scoped=true&"
import script from "./vip-list.vue?vue&type=script&lang=js&"
export * from "./vip-list.vue?vue&type=script&lang=js&"
import style0 from "./vip-list.vue?vue&type=style&index=0&id=e2603c90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2603c90",
  null
  
)

export default component.exports